import { SaveResponses } from "./ResponsesActions";
import { stepIds } from "../enums/fieldsDataConfig";

// Resuelve el query param "l" (link cifrado generado por la app linksEventos) contra NBAPI.
// Devuelve { codigo, tipoAsistenteCodigo, tipoAsistenteNombre, valor, fechaVencimiento }.
// Si el link es inválido/vencido/sin cupos, el back responde 400 con un mensaje apto para
// mostrar; se guarda en linkEvento.error y el checkout sigue con el flujo normal ("externo").
export const ResolverLinkEvento = (l) => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_LINK_EVENTO_REQUEST", payload: l });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/linkseventos/resolver`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          // El endpoint es [FromBody] string → el body es el string crudo como JSON
          // (mismo estilo que /checkout/user/data en PaymentActions.GetUserData).
          body: JSON.stringify(l),
        }
      );

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: "LOAD_LINK_EVENTO_SUCCESS", payload: data });

        // El tipo de asistente resuelto también viaja en la pre-inscripción: se guarda en el
        // step PERSONA (transformData ya manda stepPersona.tipoAsistente al back) — mismo
        // mecanismo que usa GetKnownUser para el flujo con token.
        if (data?.tipoAsistenteCodigo) {
          dispatch(SaveResponses(stepIds.PERSONA, { tipoAsistente: data.tipoAsistenteCodigo }));
        }
        return data;
      }

      const errorMessage = await response.text();
      // El back manda el mensaje como JSON string plano ("El link está vencido")
      let message = errorMessage;
      try {
        const parsed = JSON.parse(errorMessage);
        message = parsed?.Message || parsed?.message || (typeof parsed === "string" ? parsed : errorMessage);
      } catch (_) {
        // texto plano, se usa tal cual
      }
      dispatch({ type: "LOAD_LINK_EVENTO_FAIL", payload: message || "El link no es válido" });
      return null;
    } catch (error) {
      // Error de red: no bloquear el checkout — banner genérico y flujo normal.
      dispatch({
        type: "LOAD_LINK_EVENTO_FAIL",
        payload: "No se pudo validar el link — se muestra el precio general",
      });
      return null;
    }
  };
};

export const ClearLinkEvento = () => ({ type: "CLEAR_LINK_EVENTO" });
